"use client";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { resetSearchStore } from "../_utils/searchStore";

const searchPageList = [
  /^\/bons-plans\//,
  /^\/recherche\//,
  /^\/themes\//,
  /^\/voyages\//,
  /^\/voyages-culturels\//,
  /^\/sur-mesure\/individuel\/(recherche|themes|destinations)\//,
];

export const ReplaceAllOnNonSearchPage = () => {
  const pathname = usePathname();

  useEffect(() => {
    if (!searchPageList.some((page) => page.test(pathname))) resetSearchStore();
  }, [pathname]);

  return null;
};
